import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { Url } from './url';


@Injectable({ providedIn: 'root' })
export class AppConfigService {
  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return firstValueFrom(
      this.http
        .get<{ name: string }>(`${Url.apiUrl}/get/latest/web/version`)
        .pipe(
          timeout(2000), // max 2 seconds wait
          catchError((err) => {
            console.warn('Version API failed, using default version.', err);
            return of(null); // do NOT throw error
          })
        )
    ).then(res => {
      if (res?.name) {
        Url.setAppVersion(res.name);
      }
    }).catch(() => {
      // never block bootstrap
      return Promise.resolve();
    });
  }
}
